import { Page } from "@core/components/layout/page";
import {
  PageNavbar,
  PageNavbarItem,
} from "@core/components/layout/page-navbar";
import {
  ClientsPageStatusBarProvider,
  useClientsPageStatusBarContent,
} from "@crm/components/clients/clients-page-status-bar";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_headed/clients/_layout")({
  component: RouteComponent,
});

function ClientsPageLayout() {
  const statusBar = useClientsPageStatusBarContent();

  return (
    <Page className="flex flex-col bg-background rounded-lg size-full overflow-hidden">
      {statusBar ? (
        <Page.StatusBar className="[&>div]:w-full">{statusBar}</Page.StatusBar>
      ) : null}
      <Page.Content>
        <PageNavbar className="sticky top-0 z-2 bg-background">
          <PageNavbarItem
            activeOptions={{ exact: true, includeSearch: false }}
            to="/clients"
          >
            Clients
          </PageNavbarItem>
          <PageNavbarItem
            activeOptions={{ exact: true, includeSearch: false }}
            to="/clients/families"
          >
            Families
          </PageNavbarItem>
        </PageNavbar>
        <Outlet />
      </Page.Content>
    </Page>
  );
}

function RouteComponent() {
  return (
    <ClientsPageStatusBarProvider>
      <ClientsPageLayout />
    </ClientsPageStatusBarProvider>
  );
}
